import React, { useEffect, useState, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import Form, { SimpleItem, GroupItem, Label, RequiredRule, StringLengthRule, EmptyItem, AsyncRule } from 'devextreme-react/form';
import { useDispatch, useSelector } from 'react-redux'
import { billNotifyDialogAction } from '../../store/billNotify/billNotifyDialogReducer';
import { createStore, createStoreLocal } from '../../utils/proxy';
import { editorOptionsSelect, editorOptionsSelectClear, formatDate } from '../../data/app';
import { DataGrid, Button } from 'devextreme-react';
import { Column, Editing, Lookup, RequiredRule as RuleRequired, Button as ButtonGrid, Summary, TotalItem } from 'devextreme-react/data-grid';
import ItemDDBComponent from '../../components/dropdown/ItemDDBComponent';
import toCapital, { cellRender, obtenerTasaCambio, padIdInfo, valueHasAny, valueIsNullOrEmpty } from '../../utils/common';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import useItems from '../../hooks/useItems';
import { billDefault, getConfig, paymentType, typesBill } from '../../data/bill';
import { editorOptionsDropDown } from '../../components/dropdown/ClienteDropDown';
import uri from '../../utils/uri';
import Resumen from '../../components/grids/Resumen';
import Discounts from '../../components/grids/Discounts';
import { paymentMethod } from '../../data/enums';

const NuevoNotify = props => {

    const config = getConfig(2); //factura

    const { billNotifyDialog, appInfo } = useSelector(store => store);

    const {id, open, clientId} = billNotifyDialog;

    const billDefaultCustom = { ...billDefault, clientId: clientId, paymentTypeId: config.typeId == typesBill.cotizacion ? paymentType.contado : null };

    const { items, isLoading, setItems } = useItems({});
    const [bill, setBill] = useState({ ...billDefaultCustom });
    const [saving, setSaving] = useState(false);
    const [resumenData, setResumenData] = useState([]);

    let refForm = useRef();
    let refGrid = useRef();

    useEffect(() => {

        if (open) {

            http(uri.items.asCatalog).asGet().then(resp => {

                http('bill/get/maxId').asGet().then(c => {

                    setItems(resp);

                    setBill({ ...billDefaultCustom, idMax: c.idMax, clientId: clientId, billDetails: [] });

                    obtenerTasaCambio(new Date()).then(rate => {

                        if (id > 0) {
                            http(config.uri.getById(id)).asGet().then(resp => {

                                const { billDetails, ...rest } = resp;

                                setBill({ ...billDefaultCustom, ...rest , idMax: rest.id , billDetails: [...billDetails] });

                                setResumenData([...billDetails]);

                            });
                        } else {
                            if (rate)
                                setBill({ ...bill, rate: rate.value, clientId: clientId });
                        }

                    });

                });

            });
        }

    }, [open]);

    const dispatch = useDispatch();

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar articulo',
                icon: 'plus',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => refGrid.current.instance.addRow()
            }
        });
    }

    const closeDialog = (load) => {

        refForm.current.instance.resetValues();
        refGrid.current.instance.cancelEditData();

        dispatch(billNotifyDialogAction({ id: 0, clientId: null, open: false }));
        if (load) {
            let { onSave } = props;
            onSave();
        }
    }

    const onHiding = ({ load }) => {
        closeDialog(load);
    }

    const guardarFactura = async (e) => {


        let resultValidate = refForm.current.instance.validate();

        let result = resultValidate;

        if(resultValidate.complete)
            result = await resultValidate.complete; 
       
        if (result.isValid) {

            setSaving(true);
            let data = { ...bill };

            http(config.uri.insert).asPost(data).then(resp => {
                setSaving(false);
                notify(`${toCapital(config.text)} registrada correctamente`);
                closeDialog(true);
            }).catch(err => {
                setSaving(false);
                notify(err, 'error', 5000);
            });

        }
           

    }

    const setCellValue = (prop, newData, value, currentRowData) => {

        let percent = 0;
        if (bill.discountValue == "PVT1")
            percent = 0.2;
        if (bill.discountValue == "PVT2")
            percent = 0.3;
        if (bill.discountValue == "PVT3")
            percent = 0.4;

        newData[prop] = value || 0;
        if (prop == 'itemId' && value) {

            let info = items.find(x => x.id == value);

            let valor = bill.discountValue == "PVT4" ? info.cost : info.price;

            newData['price'] = valor;
            newData['cost'] = info.cost;

            !currentRowData['quantity'] && (newData['quantity'] = 1);

            newData['import'] = valor;

            newData['discount'] = (valor * percent);
            newData['subTotal'] = valor - (valor * percent);
            newData['iva'] = 0;

            !currentRowData['total'] && (newData['total'] = newData['subTotal']);

        }

        if (prop == 'quantity' && (+value) >= 0) {

            let valor = bill.discountValue == "PVT4" ? currentRowData['cost'] : currentRowData['price'];

            newData['price'] = valor;
            newData['import'] = valor * value;
            newData['discount'] = (valor * percent * value);
            newData['subTotal'] = newData['import'] - newData['discount'];
            newData['iva'] = 0;
            newData['total'] = newData['subTotal'];


        }

    }

    const onCellPrepared = e => {

        const cellsQuantity = ['quantity', 'quantityRequest']

        if (e.rowType == 'data' && e.column.allowEditing) {
            if (cellsQuantity.includes(e.column.dataField))
                e.cellElement.classList.add('quantity-text');
        }

    }


    const isTranferOrCheckOrCard = value => [paymentMethod.cheque, paymentMethod.tarjeta, paymentMethod.deposito].includes(value);


    const validatePaymentMethod = e => {
        return new Promise(resolve => {
            resolve(
                (bill.paymentTypeId == paymentType.contado && valueHasAny(bill.paymentMethodId))
                || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(bill.paymentMethodId))
            );
        });
    }

    const validateBank = e => {
        return new Promise(resolve => {
            resolve(
                (bill.paymentTypeId == paymentType.contado && bill.paymentMethodId == paymentMethod.efectivo && valueIsNullOrEmpty(bill.bankId))
                || (bill.paymentTypeId == paymentType.contado && isTranferOrCheckOrCard(bill.paymentMethodId) && valueHasAny(bill.bankId))
                || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(bill.bankId))

            );
        });
    }

    const validateReferencePayment = e => {
        return new Promise(resolve => {
            resolve(
                (bill.paymentTypeId == paymentType.contado && bill.paymentMethodId == paymentMethod.efectivo && valueIsNullOrEmpty(bill.referencePayment))
                || (bill.paymentTypeId == paymentType.contado && isTranferOrCheckOrCard(bill.paymentMethodId) && valueHasAny(bill.referencePayment))
                || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(bill.paymentMethodId))
            );
        });
    }

    // const validateReference = e => {
    //     return new Promise(resolve => {
    //         resolve(
    //             (bill.paymentTypeId == paymentType.contado && valueHasAny(bill.reference))
    //             || (bill.paymentTypeId == paymentType.credito && valueIsNullOrEmpty(bill.reference))
    //         );
    //     });
    // }

    const onRowInserted = e => {
        setResumenData([...bill.billDetails])
    }

    const applyDiscount = (e) => {

        const { value } = e;

        let percent = 0;

        if (value == "PVT1")
            percent = 0.2;
        if (value == "PVT2")
            percent = 0.3;
        if (value == "PVT3")
            percent = 0.4;

        const newData = bill.billDetails.map(x => {

            let valor = value == "PVT4" ? x.cost : x.price;


            x.price = valor
            x.import = valor * x.quantity;
            x.discount = valor * x.quantity * percent;
            x.subTotal = x.import - x.discount;
            x.total = x.subTotal;


            return x;
        });

        setBill({ ...bill, discountValue: value, billDetails: [...newData] });

    }

    useEffect(() => {
        if (open)
            obtenerTasaCambio(new Date()).then(rate => {
                if (rate)
                    setBill({ ...bill, rate: rate.value });
            });
    }, [open]);


    const disabled = id > 0;
    const padId = padIdInfo(appInfo);

    return (
        <div>
            <Popup
                width={1050}
                height={720}
                title={id > 0 ? `Ver ${config.text} No ${padId(bill.idMax)}` : `Nueva ${config.text} No ${padId(bill.idMax)}`}
                onHiding={onHiding}
                visible={open}
                className="bg-fbfbfb"
            >
                <Form formData={bill} ref={refForm}>
                    <GroupItem colCount={3}>
                        <SimpleItem dataField="date" editorType="dxDateBox"
                            editorOptions={{
                                displayFormat: formatDate,
                                openOnFieldClick: true,
                            }} >
                            <Label text="Fecha" />
                            <RequiredRule message="Seleccione la fecha" />
                        </SimpleItem>
                        <SimpleItem dataField="clientId" colSpan={2} editorType="dxSelectBox"
                            editorOptions={editorOptionsDropDown} >
                            <Label text="Cliente" />
                            <RequiredRule message="Seleccione el cliente" />
                        </SimpleItem>

                        <SimpleItem dataField="paymentTypeId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: createStore({ name: 'billPaymentType' }),
                                ...editorOptionsSelect,
                                disabled: config.typeId == typesBill.cotizacion,
                                onValueChanged: e =>  {

                                    const creditDays =  e.value == paymentType.contado ? 0 : appInfo.creditLimit;

                                    setBill({ ...bill, 
                                        paymentTypeId: e.value, 
                                        creditDays: creditDays,
                                        paymentMethodId : null,
                                        bankId : null,
                                        referencePayment : ''
                                    })
                                } 
                            }} >
                            <Label text="Tipo pago" />
                            <RequiredRule message="Seleccione el tipo" />
                        </SimpleItem>
                        <SimpleItem dataField="creditDays" editorType="dxNumberBox"
                            editorOptions={{
                                disabled: true
                            }} >
                            <Label text="Dias crédito" />
                            <RequiredRule message="Seleccione el tipo" />
                        </SimpleItem>
                        <SimpleItem dataField="reference" >
                            <Label text="No Factura" />
                            <RequiredRule message="Ingrese la referencia" />
                        </SimpleItem>
                        <SimpleItem dataField="paymentMethodId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: createStore({ name: 'billPaymentMethod' }),
                                ...editorOptionsSelectClear,
                                disabled: (config.typeId == typesBill.cotizacion || bill.paymentTypeId != paymentType.contado),
                            }} >
                            <Label text="Forma pago" />
                            <AsyncRule message="Seleccione la forma de pago" validationCallback={validatePaymentMethod}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="bankId" editorType="dxSelectBox"
                            editorOptions={{
                                dataSource: createStore({ name: 'Bank' }),
                                ...editorOptionsSelectClear,
                                disabled: (config.typeId == typesBill.cotizacion || bill.paymentTypeId != paymentType.contado),
                            }} >
                            <Label text="Banco" />
                            <AsyncRule message="Seleccione el banco" validationCallback={validateBank}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="referencePayment"
                            editorOptions={{
                                disabled:  bill.paymentTypeId != paymentType.contado
                            }} >
                            <Label text="Referencia" />
                            <AsyncRule message="Ingrese la referencia" validationCallback={validateReferencePayment}></AsyncRule>
                        </SimpleItem>
                        <SimpleItem dataField="observation" colSpan={3} >
                            <Label text="Observacion" />
                            <StringLengthRule max={150} message="Maximo 150 caracteres" />
                        </SimpleItem>
                    </GroupItem>
                    <GroupItem>
                        <DataGrid id="gridDetails"
                            ref={refGrid}
                            selection={{ mode: 'single' }}
                            dataSource={bill.billDetails}
                            showBorders={true}
                            showRowLines={true}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                            height={290}
                            onToolbarPreparing={onToolbarPreparing}
                            onCellPrepared={onCellPrepared}
                            onRowInserted={onRowInserted}
                            onRowUpdated={onRowInserted}
                        >
                            <Column dataField="itemId" caption="Producto"
                                setCellValue={setCellValue.bind(null, "itemId")}
                                editCellComponent={ItemDDBComponent}
                            >
                                <Lookup
                                    dataSource={items}
                                    valueExpr="id"
                                    displayExpr={item => item ? `${item.code} - ${item.name}` : ''}

                                />
                                <RuleRequired />
                            </Column>
                            <Column dataField="quantity" caption="Cantidad" dataType="number" width={80}
                                setCellValue={setCellValue.bind(null, "quantity")}
                            >
                                <RuleRequired />
                            </Column>
                            <Column dataField="price" caption="Precio Vta" dataType="number" width={100} allowEditing={false} cellRender={cellRender()} >
                                <RuleRequired />
                            </Column>
                            <Column dataField="total" caption="Total" dataType="number" width={150} allowEditing={false} cellRender={cellRender()} >
                                <RuleRequired />
                            </Column>
                            <Column type="buttons" width={50}>
                                <ButtonGrid name="delete" />
                            </Column>

                            <Editing
                                mode="cell"
                                allowDeleting={true}
                                allowUpdating={true}
                                selectTextOnEditStart={true}
                                useIcons={true}
                            ></Editing>
                            {/* <Summary>
                                <TotalItem
                                    column="total"
                                    summaryType="sum"
                                    customizeText={data => `Total: ${formatToMoney(data.value)}`}
                                />
                            </Summary> */}
                        </DataGrid>
                        <Discounts value={bill.discountValue} callback={applyDiscount} />
                        <Resumen data={resumenData} bill={bill} />
                    </GroupItem>
                </Form>

                <Button
                    className="mt-10"
                    text={saving ? 'Guardando...' : `Guardar ${config.text}`}
                    type="success"
                    icon='save'
                    disabled={saving || disabled}
                    onClick={guardarFactura}
                />
            </Popup>
        </div>
    );
}

export default NuevoNotify;
